import { _ as _defineProperty } from '../../defineProperty-18999f8e.js';
import { L as LayerType } from '../../common-94559169.js';
import '../../configs/index.js';
import getBaseLayerDefaultAttrs from '../base/index.js';
import '../../v4-c5e36445.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getColorLayerDefaultAttrs = function getColorLayerDefaultAttrs() {
  return _objectSpread(_objectSpread({}, getBaseLayerDefaultAttrs()), {}, {
    type: LayerType.COLOR_LAYER,
    colorTransparent: false
  });
};

export { getColorLayerDefaultAttrs as default };
